/**
 * @desc 获取sku信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(skuNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/wms/skuInfo/info/${skuNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
